import slugify from "slugify";
import Vue from "vue";
import { Route } from "vue-router";

import { LogService } from "@/services";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/ban-types
    dataLayer: object[];
    // dataLayer: Record<string, unknown>;
  }
}

export class VignetteHelpers {
  static focusToElement(that: Vue, elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      LogService.info(`VignetteHelpers.focusToElement: Scrolling to element with id: ${elementId}`);
      that.$nextTick(() => element.scrollIntoView({ behavior: "smooth" }));
    } else {
      LogService.info(`VignetteHelpers.focusToElement: element with id: ${elementId} not found.`);
    }
  }

  static slugify(text: string): string {
    return slugify(text, { lower: true, remove: /[>%_\\$~&+,<:;/=?@#`|'.^*()!\[\]{}"-]/g });
  }

  static getProfileNameSlug(profileName: string): string {
    return "-" + VignetteHelpers.slugify(profileName);
  }

  static readQueryStr(route: Route, name: string, defaultVal: string): string {
    if (!route.query) {
      return defaultVal;
    } else if (route.query[name] instanceof Array) {
      return route.query[name][0] || defaultVal;
    } else {
      return (route.query[name] as string) || defaultVal;
    }
  }

  static readQueryTruthy(route: Route, name: string): boolean | undefined {
    if (!route.query) {
      return undefined;
    } else if (route.query[name] instanceof Array) {
      return !!route.query[name][0];
    } else {
      const query = route.query[name] as string;
      // Check if querystring is defined in URL but empty, null or "" is returned from router (instead of undefined)
      if (query === undefined) return undefined;
      else return query == null || query === "" || query === "true";
    }
  }

  static readQueryNum(route: Route, name: string, defaultVal: number): number {
    try {
      if (typeof route.query[name] === "string") {
        return Number.parseInt(route.query[name] as string);
      } else {
        if (route.query[name][0] != null) {
          return Number.parseInt(route.query[name][0] || "");
        }
      }
    } catch (e) {}

    return defaultVal;
  }

  static Analytics = class {
    // eslint-disable-next-line @typescript-eslint/ban-types
    static push(item: object): void {
      LogService.info(`Analytics - sending new metadata`);
      window.dataLayer.push(item);
    }
    static pushEvent(eventName: string): void {
      LogService.info(`Analytics - sending event beacon: '${eventName}'`);
      window.dataLayer.push({
        event: eventName,
      });
    }
  };
}
